module.exports = __webpack_public_path__ + "img/tree-06-e-leaves.12d77763.png";